import { Typography, Button } from "../../components"
import "./styles.css";

export default function RoutekaartLactatiekundigen(props) {
    return (
        <div className="container">
            <iframe
                title="Routekaart NOLIA BabyFeeding voor lactatiekundigen"
                src="https://app.enormail.eu/subscribe/027df82668429a14308015c98bbeba88"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}